// import React, { createContext, useContext, useState, useEffect } from 'react';

// const AuthContext = createContext();

// export function useAuth() {
//   const context = useContext(AuthContext);
//   if (!context) {
//     throw new Error('useAuth must be used within AuthProvider');
//   }
//   return context;
// }

// export function AuthProvider({ children }) {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [isAuthChecked, setIsAuthChecked] = useState(false);

//   const checkAuth = () => {
//     const token = localStorage.getItem('accessToken');
//     const authState = !!token;
//     setIsAuthenticated(authState);
//     setIsAuthChecked(true);
//     return authState;
//   };

//   useEffect(() => {
//     checkAuth();

//     window.addEventListener("authLogout", checkAuth);

//     window.addEventListener("storage", (e) => {
//       if (e.key === 'accessToken') {
//         checkAuth();
//       }
//     });

//     return () => {
//       window.removeEventListener("authLogout", checkAuth);
//       window.removeEventListener("storage", checkAuth);
//     };
//   }, []);

//   const handleLogin = () => {
//     setIsAuthenticated(true);
//   };

//   const handleLogout = () => {
//     localStorage.removeItem('accessToken');
//     localStorage.removeItem('refreshToken');
//     localStorage.removeItem('lastVisitedRoute');
//     setIsAuthenticated(false);
//     window.dispatchEvent(new Event('authLogout'));
//   };

//   const value = {
//     isAuthenticated,
//     isAuthChecked,
//     handleLogin,
//     handleLogout,
//     setIsAuthenticated
//   };

//   return (
//     <AuthContext.Provider value={value}>
//       {children}
//     </AuthContext.Provider>
//   );
// }

import React, { createContext, useContext, useState, useEffect } from "react";
import useFirebaseNotifications from "../hooks/useFirebaseNotifications";
import { resetAllStores } from "../store/resetStores";
import { clearPlanSelection } from "../utils/cookies";
import api from "../services/api";

const AuthContext = createContext();

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
}

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  const [hasInitialized, setHasInitialized] = useState(false);

  const checkAuth = () => {
    const token = localStorage.getItem("accessToken");
    const authState = !!token;

    setIsAuthenticated(authState);
    setIsAuthChecked(true);

    // Reset initialization flag on logout
    if (!authState && hasInitialized) {
      setHasInitialized(false);
    }

    return authState;
  };

  useEffect(() => {
    checkAuth();

    window.addEventListener("authLogout", checkAuth);

    window.addEventListener("storage", (e) => {
      if (e.key === "accessToken") {
        checkAuth();
      }
    });

    return () => {
      window.removeEventListener("authLogout", checkAuth);
      window.removeEventListener("storage", checkAuth);
    };
  }, [hasInitialized]);

  // Initialize Firebase notifications (runs once)
  useFirebaseNotifications();

  // Initialize app data only once when authenticated
  useEffect(() => {
    if (isAuthenticated && !hasInitialized) {
      // This will trigger useInitializeAppData which fetches currency and org data
      setHasInitialized(true);
    }
  }, [isAuthenticated, hasInitialized]);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = async () => {
    try {
      const refreshToken = localStorage.getItem("refreshToken");
      if (refreshToken) {
        await api.post("user-accounts/logout/", { refresh: refreshToken });
      }
    } catch (error) {
      console.error("Logout API notification failed:", error);
    } finally {
      resetAllStores();
      clearPlanSelection();
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("bearer");
      localStorage.removeItem("lastVisitedRoute");
      setIsAuthenticated(false);
      setHasInitialized(false); // Reset initialization flag
      window.dispatchEvent(new Event("authLogout"));
    }
  };

  const value = {
    isAuthenticated,
    isAuthChecked,
    hasInitialized,
    handleLogin,
    handleLogout,
    setIsAuthenticated,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
